import { Card, LinearProgress, styled } from "@mui/material";
import { FC } from "react";

const StyledCard = styled(Card)(() => ({
  position: "relative",
}));

interface IProgressCardProps {
  loading?: boolean;
  extraStyles?: any;
  children: any;
}

const ProgressCard: FC<IProgressCardProps> = ({
  children,
  loading,
  extraStyles = {},
}) => {
  return (
    <StyledCard sx={{ ...extraStyles }}>
      {loading && <LinearProgress />}
      {children}
      {loading && <FaintLayer />}
    </StyledCard>
  );
};

const FaintLayer = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 100,

  backgroundColor: theme.palette.background.default,
  opacity: 0.5,
}));

export default ProgressCard;
